import styled from 'styled-components';

const BirthdateInputStyles = styled.div`
    input::-webkit-datetime-edit {
        font-family: var(--copy-font);
        color: var(--gray-300);
        font-size: 12px;
    }
    input.entered {
        background: #fff;
    }
    input.entered::-webkit-datetime-edit {
        color: var(--gray-500);
        background: #fff;
        padding: 0;
    }
`;

export default BirthdateInputStyles;
